export default "__VITE_ASSET__7bace471__"